<template>
  <div class="lesson">
    <section class="detailWrapper">
      <el-breadcrumb class="title nav-bar-route-box" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item v-for="item in routeArr" :key="item.path">
          <a class="title" @click="backIndex(item.title)">{{ item.title }}</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
      <div class="first mb32">
        <img class="image" :src="lessonDeatil.detail[0]" alt="" />
        <el-button type="primary" class="onlineBtn" @click="onlineEvent">联系我们</el-button>
        <!-- <el-button type="primary" class="onlineContractBtn" @click="onlineContractEvent">在线联系</el-button> -->
      </div>
      <div>
        <img class="img" :src="lessonDeatil.detail[1]" alt="" />
      </div>
    </section>

    <Contract
      :contractVisible="contractVisible"
      @cancel="contractClose"
      @confirm="contractConfirm"
    />

    <LoginDialog
      :loginVisible="loginVisible"
      @cancel="loginClose"
      @confirm="loginConfirm"
    />

    <Online
      :onlieContractVisible="onlieContractVisible"
      @cancel="onlineClose"
      @confirm="onlineConfirm"
    />
  </div>
</template>

<script>
import Contract from '../../components/contract.vue'
import LoginDialog from '../../components/login.vue'
import Online from '../../components/online.vue'
export default {
  name: 'LessonDetail',
  components: {
    Contract,
    LoginDialog,
    Online
  },
  data () {
    return {
      routeArr: [],
      contractVisible: false,
      onlieContractVisible: false,
      loginVisible: false,
      lessonDeatil: {}
    }
  },
  created () {
    const matched = this.$route.matched
    this.lessonDeatil = JSON.parse(localStorage.getItem('LESSON_DETAIL'))
    matched[0] && (matched[0].title = this.lessonDeatil.type)
    matched[1] && (matched[1].title = this.lessonDeatil.title)
    this.routeArr = matched
    console.log(this.routeArr)
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    })
  },
  methods: {
    backIndex (title) {
      var listName
      if (title === '外语口语') {
        listName = 'IDX1'
      } else if (title === '对外口语') {
        listName = 'IDX2'
      } else if (title === '逻辑思维') {
        listName = 'IDX3'
      } else {
        return
      }
      this.$router.push({
        path: '/?listName=' + listName
      })
    },
    onlineEvent () {
      this.contractVisible = true
    },
    contractClose () {
      this.contractVisible = false
    },
    contractConfirm () {
      this.contractVisible = false
    },
    onlineContractEvent () {
      if (sessionStorage.getItem('TOKEN')) {
        this.onlieContractVisible = true
      } else {
        this.loginVisible = true
      }
    },
    loginClose () {
      this.loginVisible = false
    },
    loginConfirm () {
      this.loginVisible = false
    },
    onlineClose () {
      this.onlieContractVisible = false
    },
    onlineConfirm () {
      this.onlieContractVisible = false
    }
  }
}
</script>
<style scoped lang="scss">
  .lesson{
    height: auto;
    min-height: 768px;
    width: 1192px;
    margin: 0 auto;
    padding-bottom: 60px;
    .title{
      height: 55px;
      font-size: 14px;
      color: #666;
      text-align: left;
      line-height: 80px;
    }
    .img{
      display: block;
      height: auto;
      width: 100%;
    }
    .mb32{
      margin-bottom: 32px;
    }
    .mb60 {
      margin-bottom: 60px;
    }
    .first{
      width: 1192px;
      // height: 473px;
      position: relative;
      .image {
        display: block;
        height: 368px;
        width: 1192px;
      }
      .onlineBtn{
        position: absolute;
        top: 325px;
        right: 537px;
        width: 110px;
        color: #fff;
        background-color: #BC1A33;
        border-color: #BC1A33;
      }
      .onlineContractBtn{
        position: absolute;
        top: 264px;
        right: 425px;
        width: 110px;
        background-color: #fff;
        border-color: #BC1A33;
        color: #BC1A33;
      }
    }
  }
</style>
